import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
} // https://auth0.com/docs/libraries/auth0-spa-js
// https://auth0.com/docs/quickstart/spa/react/01-login
// https://auth0.com/docs/quickstart/spa/react/02-calling-an-api


import { useEffect, useCallback } from "react";
import { useAuth, Provider } from "./context";
export var useIsAuthenticated = function useIsAuthenticated() {
  var _useAuth = useAuth(),
      isAuthenticated = _useAuth.isAuthenticated;

  return isAuthenticated;
};
export var useLogin = function useLogin(location, path) {
  if (path === void 0) {
    path = "";
  }

  var _useAuth2 = useAuth(),
      client = _useAuth2.client,
      isAuthenticated = _useAuth2.isAuthenticated;

  var isInitialized = !!client;
  useEffect(function () {
    if (isInitialized && !isAuthenticated) {
      client.loginWithRedirect({
        redirect_uri: "" + (location === null || location === void 0 ? void 0 : location.origin) + path,
        appState: location === null || location === void 0 ? void 0 : location.href
      });
    }
  }, [client, isAuthenticated, isInitialized, location, path]);
  return isAuthenticated;
};
export var useLogout = function useLogout() {
  var _useAuth3 = useAuth(),
      client = _useAuth3.client;

  return useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _len,
        p,
        _key,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len = _args.length, p = new Array(_len), _key = 0; _key < _len; _key++) {
              p[_key] = _args[_key];
            }

            return _context.abrupt("return", client === null || client === void 0 ? void 0 : client.logout.apply(client, p));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [client]);
};
export { Provider as AuthProvider };